import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { ApplicationUser } from '@global/models/accounts/application-user';
import { CookieHelper } from 'projects/advisor/src/app/shared/helpers/cookie-helper';
import { UserAccountType } from 'projects/advisor/src/app/core/models/users/user';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "projects/advisor/src/app/core/services/branding.service";
import * as i3 from "./broadcast.service";
export class AuthService {
    constructor(_router, _branding, _broadcastService) {
        this._router = _router;
        this._branding = _branding;
        this._broadcastService = _broadcastService;
        this.redirectUrl = null;
        this.loginPopupVisible = false;
        this.loadAuthorisation();
        this.loginPopupVisible = false;
    }
    get user() {
        return this._user;
    }
    getToken() {
        return this._token;
    }
    getTokenExpiration() {
        return this._tokenExpiration;
    }
    setHangfireCookie() {
        CookieHelper.setCookie('HangfireCookie', this._token);
    }
    // Authorisations
    loadAuthorisation() {
        console.log('%c[[Auth-Service]]: Loading authorisations...', 'color: green; font-weight: bold;');
        this._token = null;
        this._tokenExpiration = null;
        this._user = null;
        // Load the Token
        this._token = localStorage.getItem('authToken');
        const tokenExpirationString = localStorage.getItem('authTokenExpirationDate');
        if (tokenExpirationString != null) {
            this._tokenExpiration = JSON.parse(tokenExpirationString);
            this._tokenExpiration = moment(this._tokenExpiration);
        }
        // Application User
        const applicationUserString = localStorage.getItem('applicationUser');
        if (applicationUserString !== null) {
            const obj = JSON.parse(applicationUserString);
            if (obj.staff) {
                // This is an old version of the IApplicationUser..
                // This can be deleted at some stage :P
                if (obj.staff) {
                    obj.AccountType = UserAccountType.Staff;
                }
                else {
                    obj.AccountType = UserAccountType.Advisor;
                }
                delete obj['staff'];
            }
            this._user = ApplicationUser.new(obj);
        }
        if (!this.isAuthenticated()) {
            console.log('%c[[Auth-Service]]: No authentication token.', 'color: green; font-weight: bold;');
            this.clearAuthentication();
            return;
        }
        this._branding.organisationId = this.user.organisationId;
        this._branding.invalidCache = true;
        this._broadcastService.connect(this._token);
    }
    setAuthorisation(result) {
        console.log('%cAuth-Guard: Set authorisation...', 'color: green;');
        // Token
        this._token = result.token;
        this._tokenExpiration = moment(result.expirationDateUtc);
        console.log(`Token Expiration: ${this._tokenExpiration}`, 'color: green;');
        localStorage.setItem('authToken', this._token);
        localStorage.setItem('authTokenExpirationDate', JSON.stringify(this._tokenExpiration));
        // TFA Token
        if (result.tfaToken) {
            localStorage.setItem('TfaToken', result.tfaToken);
        }
        // Application User
        this._user = ApplicationUser.new(result.applicationUser);
        const applicationUserString = JSON.stringify(this._user);
        localStorage.setItem('applicationUser', applicationUserString);
        this.loginPopupVisible = false;
        this._branding.organisationId = result.applicationUser.organisationId;
        this._branding.invalidCache = true;
        // this.loadIntercom();
        this._broadcastService.connect(this._token);
    }
    /*
    private loadIntercom(): void {
        if (this.user) {
            // TODO: This needs to move to login
            window.Intercom('boot', {
                app_id: 'ock7jo2o',
                name: this.user.fullName,
                email: this.user.emailAddress,
                created_at: moment().unix() // Signup date as a Unix timestamp
            });
        }
    }
    */
    // clear token remove user from local storage to log user out
    clearAuthentication() {
        // Token
        this._token = null;
        this._tokenExpiration = null;
        localStorage.removeItem('authToken');
        localStorage.removeItem('authTokenExpirationDate');
        // Application User: Keep this so that if your logged out due to a timeout and a login popup is enabled it doesn't break the underlying page.
        // this._user = null;
        // localStorage.removeItem('applicationUser');
    }
    showLogin(usePopup) {
        if (this._router.url === '/login') {
            return;
        }
        if (this._router.url === '/forgot') {
            return;
        }
        if (this._router.url === '/recover') {
            return;
        }
        if (this._router.url === '/welcome') {
            return;
        }
        if (this._router.url === '/test') {
            return;
        }
        if (this._router.url === '/unsubscribe') {
            return;
        }
        if (this._router.url === '/problem') {
            return;
        }
        console.log(`%cAuth Service: showLogin(usePopup: ${usePopup}) called.`, 'color: green;');
        if (usePopup) {
            this.loginPopupVisible = false;
            this.loginPopupVisible = true;
        }
        else {
            this._router.navigate(['/login']);
        }
        this.clearAuthentication();
    } // End showLogin
    logout() {
        this._broadcastService.disconnect();
        this.clearAuthentication();
    }
    //
    // Authenitication
    //
    isAuthenticated() {
        if (this._token == null || this._tokenExpiration == null) {
            return false;
        }
        if (moment.utc().isSameOrAfter(this._tokenExpiration)) {
            return false;
        }
        return true;
    }
    isStaff() {
        if (!this.user) {
            return false;
        }
        return this.user.accountType === UserAccountType.Staff;
    }
    isAdvisor() {
        if (!this.user) {
            return false;
        }
        return this.user.accountType === UserAccountType.Advisor;
    }
    isTrustee() {
        if (!this.user) {
            return false;
        }
        return this.user.accountType === UserAccountType.Trustee;
    }
    isDeveloper() {
        if (!this.user) {
            return false;
        }
        return this.user.id === 628;
    }
}
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.BrandingService), i0.ɵɵinject(i3.BroadcastService)); };
AuthService.ɵprov = i0.ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Router }, { type: i2.BrandingService }, { type: i3.BroadcastService }]; }, null); })();
//# sourceMappingURL=auth.service.js.map